import React, { Fragment, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import {
  getCustomerInfoFromStroge,
  getShopDataFromStrg,
} from "../../pages/Home/utils";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import useGetCurrency from "../../hooks/useGetCurrency";
import SimpleButton from "./SimpleButton";

import { IACTIVESUBPLAN, SUBSPALNLIST } from "../interfaces";
import ErrorModal from "./ErrorModal";
import useSubsPlan from "../../hooks/useSubsPlan";
import PaymentRow from "../../pages/Home/Components/Popups/CartPages/CartComponents/PaymentRow";
import useSelectedLanguge from "../../hooks/useSelectedLanguge";
import IconInfo from "../../assets/img/svgs/IconInfo";
import Loader from "../../modules/Loader";
import usePaymentGateways from "../../hooks/useGetPayments";

interface Prop {
  onPressClose: () => void;
  selectedLang: string;
  userPlan: IACTIVESUBPLAN | undefined;
  lastSelectedPlan?: SUBSPALNLIST;
}
const SubscriptionPlan: React.FC<Prop> = (props: Prop) => {
  const { t } = useTranslation();
  const { gateWaysData, getPaymentGateways, gatewayLoading } =
    usePaymentGateways();
  const {
    loading,
    getSubList,
    subsPlanList,
    availSubsPlan,
    getActiveSub,
    planApiError,
    subsActivePlan,
  } = useSubsPlan();
  const { onPressClose, userPlan, selectedLang, lastSelectedPlan } = props;
  const { bussinessName } = useParams();
  const [customerInfo] = useState(getCustomerInfoFromStroge());
  const { currency } = useGetCurrency();
  const [userActivePlan, setActivePlan] = useState<IACTIVESUBPLAN | undefined>(
    userPlan
  );

  const { selectedLanguageCode } = useSelectedLanguge();
  const [showError, setShowError] = useState(false);
  const [redirectingLoading, setRedirectingLoading] = useState(false);
  const [showPlanError, setPlanShowError] = useState(false);
  const [showSuccess, setShowSuccess] = useState(false);
  const [showFailure, setShowFailure] = useState(false);
  const valuesFromStorage = getShopDataFromStrg("/" + bussinessName!);
  const shopInfo = valuesFromStorage !== null && valuesFromStorage?.shopInfo;
  const gateWayName = shopInfo?.resto_meta?.BILLING_GATEWAY[0].value;
  const [searchParams, setSearchParams] = useSearchParams();
  const navigation = useNavigate();
  const submitPlanHandler = (plan: SUBSPALNLIST) => {
    console.log(gateWaysData);
    const firstGateway = Object.values(gateWaysData)[0];
    //@ts-ignore
    const gatewayName = firstGateway.gatewayName;
    if (null !== customerInfo) {
      availSubsPlan(plan.id, gatewayName).then((response) => {
        setRedirectingLoading(true);
        if (response && response.success) {
          setTimeout(() => {
            window.open(response.res.data.payment_link, "_self");
          }, 100);
        } else {
          setRedirectingLoading(false);
        }
      });
    } else {
      navigation(`/${bussinessName}/send-otp`, {
        state: {
          navigateBackTo: "SubscriptionPlan",
          planObj: plan,
        },
      });
    }
  };
  const RenderPlanRow = ({ labelValue, isShowButton, actualValue }: any) => {
    return (
      <div className="cart_content_row">
        <div
          className="cart_content_col_70 flo_left"
          style={{
            flexDirection: "row",
            display: "flex",
            alignItems: "center",
          }}
        >
          <div>{labelValue}</div>
          {isShowButton && (
            <IconInfo
              onPress={() => {
                //onPressIcon
              }}
              style={{ marginRight: 5, marginLeft: 5, cursor: "pointer" }}
            />
          )}
        </div>
        <div className="cart_content_col_30">
          {selectedLang === "en" && currency} {actualValue}{" "}
          {selectedLang === "ar" && currency}
        </div>
      </div>
    );
  };
  useEffect(() => {
    if (
      searchParams.get("type") === "subscription" &&
      searchParams.get("reason") === "Success"
    ) {
      setShowSuccess(true);
    }
    if (
      searchParams.get("type") === "subscription" &&
      searchParams.get("reason") === "Failure"
    ) {
      setShowFailure(true);
    }
    getPaymentGateways();
    if (null !== customerInfo && !userPlan) {
      getActiveSub(customerInfo.id);
    }
  }, []);
  useEffect(() => {
    if (subsActivePlan) {
      setActivePlan(subsActivePlan);
    }
  }, [subsActivePlan]);
  useEffect(() => {
    if (!userPlan) {
      getSubList();
    }
  }, [userPlan]);
  // useEffect(() => {
  //   if (lastSelectedPlan && !gatewayLoading && gateWaysData) {
  //     if (Object.keys(gateWaysData).length > 0)
  //       submitPlanHandler(lastSelectedPlan);
  //   }
  // }, [lastSelectedPlan, gatewayLoading, gateWaysData]);
  useEffect(() => {
    if (planApiError && planApiError.isError) {
      setPlanShowError(true);
    }
  }, [planApiError]);
  return (
    <div
      id="pop_time_set"
      className="pop_up_maps_main pop_main_menu_bg "

      // style={{ background: "rgba(0, 0, 0, 0.5)" }}
    >
      <div
        style={{
          ...styles.container,

          overflowY: "scroll",
        }}
        className=" popup_delivery popup_from_bottom pop_time_set_height popup_slide"
      >
        <div className="delivery_close" style={{ marginBottom: 10 }}>
          <span
            className="slide_remove cross_button"
            onClick={() => onPressClose()}
          >
            &times;
          </span>
        </div>
        <div
          style={{
            fontSize: 22,
            fontWeight: "bold",
            marginBottom: 10,
          }}
        >
          {t("subs_pop_heading")}
        </div>
        <div
          style={{
            color: "rgba(140, 140, 140, 1)",
            marginBottom: 15,
          }}
        >
          {t("subs_pop_desc")}
        </div>
        {redirectingLoading && (
          <div className="loader-overlay">
            <div className="spinner"></div>
            <p>Redirecting to payment...</p>
          </div>
        )}
        {loading && (
          <Fragment>
            {/* <SkeltonLoader /> */}
            <Loader colorProp="black" height={50} width={50} />
          </Fragment>
        )}

        {!loading && (
          <Fragment>
            {userActivePlan && (
              <Fragment>
                <div style={styles.walletInfo}>
                  {userActivePlan.plan_title}
                  {/* {`You have AED ${customerPoints} in your wallet`} */}
                </div>

                <div
                  style={{ fontSize: 16, fontWeight: "bold", marginBottom: 15 }}
                >
                  {t("remaining_subs_title")}
                </div>
                <RenderPlanRow
                  isShowButton={false}
                  labelValue={t("per_order_discount_limit")}
                  actualValue={userActivePlan.per_order_discount_limit}
                />

                <RenderPlanRow
                  isShowButton={false}
                  labelValue={t("used_subscription_amount")}
                  actualValue={userActivePlan.used_subscription_amount}
                />

                <RenderPlanRow
                  isShowButton={false}
                  labelValue={t("remaining_subscription_amount")}
                  actualValue={userActivePlan.remaining_subscription_amount}
                />

                <div
                  style={{
                    fontSize: 16,
                    fontWeight: "bold",
                    marginBottom: 10,
                    marginTop: 10,
                  }}
                >
                  {t("subs_plan_details")}
                </div>
                <RenderPlanRow
                  isShowButton={false}
                  labelValue={t("plan_value")}
                  actualValue={userActivePlan.plan_amount}
                />

                <RenderPlanRow
                  isShowButton={false}
                  labelValue={t("max_total_discount")}
                  actualValue={userActivePlan.max_total_discount}
                />
                {/* per_order_discount_limit */}
                {/* <div className="disp_flex">
                  <div>{t("max_total_discount")}</div>
                  <div>{subsActivePlan.max_total_discount}</div>
                </div> */}
              </Fragment>
            )}
            {!userActivePlan &&
              subsPlanList &&
              subsPlanList.length > 0 &&
              subsPlanList.map((item, index) => {
                return (
                  <Fragment key={index}>
                    <div
                      style={{ ...styles.walletInfo, ...styles.displayFlex }}
                    >
                      {item.plan_title}
                      <div>
                        {selectedLanguageCode == "en" ? (
                          <span>
                            {currency} {item.price}
                          </span>
                        ) : (
                          <span>
                            {item.price} {currency}
                          </span>
                        )}
                      </div>
                    </div>

                    <div
                      dangerouslySetInnerHTML={{
                        __html: item.description,
                      }}
                    ></div>

                    <SimpleButton
                      t={t}
                      loading={loading}
                      titleProp={t("txt_avail")}
                      onPressHandler={() => {
                        submitPlanHandler(item);
                      }}
                    />
                  </Fragment>
                );
              })}
          </Fragment>
        )}
        <br />
        {showSuccess && (
          <ErrorModal
            headerMessage={t("lbl_success")}
            buttonMessage="Continue"
            onPressClose={() => {
              setShowSuccess(false);
              searchParams.delete("type");
              searchParams.delete("plan_id");
              searchParams.delete("business_id");
              searchParams.delete("payment");
              searchParams.delete("customer_id");
              searchParams.delete("reason");
              setSearchParams(searchParams);
            }}
            onBackDropClick={() => setShowError(false)}
            errorMessage={t("subs_success_msg")}
          />
        )}
        {showFailure && (
          <ErrorModal
            headerMessage={t("lbl_failure")}
            buttonMessage="try again"
            onPressClose={() => {
              setShowFailure(false);
              searchParams.delete("type");
              searchParams.delete("plan_id");
              searchParams.delete("business_id");
              searchParams.delete("payment");
              searchParams.delete("customer_id");
              searchParams.delete("reason");
              setSearchParams(searchParams);
            }}
            onBackDropClick={() => setShowError(false)}
            errorMessage={t("subs_failure_msg")}
          />
        )}
        {/* planApiError */}
        {showPlanError && (
          <ErrorModal
            headerMessage="Error"
            buttonMessage="Ok"
            onPressClose={() => {
              setPlanShowError(false);
            }}
            onBackDropClick={() => setShowError(false)}
            errorMessage={planApiError.errorMessage}
          />
        )}
        {showError && (
          <ErrorModal
            headerMessage="Error"
            buttonMessage="Ok"
            onPressClose={() => {
              setShowError(false);
            }}
            onBackDropClick={() => setShowError(false)}
            errorMessage={"Something went wrong please try again"}
          />
        )}
      </div>
    </div>
  );
};

export default SubscriptionPlan;

const styles = {
  container: {
    maxHeight: "90%",
    overflow: "hidden",
    paddingLeft: 25,
    paddingRight: 15,
    paddingTop: 10,
  },
  labelStyle: {
    color: "black",
    fontSize: "1.7rem",
  },
  mgBottom: {
    // marginBottom: 10,
    marginLeft: 5,
    color: "#828282",
  },
  displayFlex: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
  },
  walletInfo: {
    marginTop: 20,
    marginBottom: 20,
    paddingTop: "1rem",
    width: "32rem",
    paddingBottom: "1rem",
    borderRadius: "99999px",
    paddingLeft: "1.5rem",
    paddingRight: "1.5rem",
    border: "1px solid #00d2a3",
    color: "#00d2a3",
  } as React.CSSProperties,
  borderSuccess: {
    borderColor: "#00d2a3",
  },
};
